import * as React from 'react';
import { Row } from 'react-bootstrap';

import LockedValue from 'af-components/LockedValue';

import SettingPreview from '../../Shared/SettingPreview';

interface Props {
	toggleEdit: () => void;
	timeBetweenShifts: number;
	maximumShiftDurationBeforeBreak1: number;
	maximumShiftDurationBeforeBreak2: number;
	minimumBreakDuration: number;
}

const ShiftSettingsPreview: React.FC<Props> = (props) => {
	const { toggleEdit, timeBetweenShifts, maximumShiftDurationBeforeBreak1, maximumShiftDurationBeforeBreak2, minimumBreakDuration } = props;

	return (
		<SettingPreview toggleEdit={toggleEdit}>
			<div className="company-settings__info-segment">
				<Row className="row--padded">
					<LockedValue
						label="Time between shifts"
						value={`${timeBetweenShifts / 60} hours`}
					/>
				</Row>
				<Row className="row--padded">
					<LockedValue
						label={<span>Maximum shift duration before the <b>first break</b></span>}
						value={!!maximumShiftDurationBeforeBreak1 ? `${maximumShiftDurationBeforeBreak1 / 60} hours` : 'No maximum shift duration before the first break selected'}
					/>
				</Row>
				<Row className="row--padded">
					<LockedValue
						label={<span>Maximum shift duration before the <b>second break</b></span>}
						value={!!maximumShiftDurationBeforeBreak2 ? `${maximumShiftDurationBeforeBreak2 / 60} hours` : 'No maximum shift duration before the second break selected'}
					/>
				</Row>
				<Row className="row--padded">
					<LockedValue
						label="Minimum break duration"
						value={!!minimumBreakDuration ? `${minimumBreakDuration} minutes` : 'No minimum break duration selected'}
					/>
				</Row>
			</div>
		</SettingPreview>
	);
};

export default React.memo(ShiftSettingsPreview);
